exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "\n.footer-wrapper {\n  padding: 4px 0 2px;\n  font-size: 12px;\n  color: #757575;\n  text-align: center;\n  background: #f4f4f4;\n}\n.footer-wrapper .lang-wrapper {\n  padding: 8px 0;\n}\n.footer-wrapper .lang-wrapper ul {\n  display: block;\n  margin: 0 auto;\n  width: 324px;\n}\n.footer-wrapper .lang-wrapper ul>li {\n  display: block;\n  list-style: none;\n  float: left;\n  width: 80px;\n  text-align: center;\n  border-right: 1px solid #7f7f7f;\n}\n.footer-wrapper .lang-wrapper ul>li:last-child {\n  border: none;\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader?{"minimize":false,"sourceMap":false}!./~/vue-loader/lib/style-compiler?{"id":"data-v-0de41ea6","scoped":false,"hasInlineConfig":false}!./~/stylus-loader?{"sourceMap":false}!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/components/footer/footer.vue
// module id = 25
// module chunks = 1 2 3 4 5 6 7